import chalk from 'chalk';

export const PLUS_ICON = chalk.green('\u002B ');

export const CHECK_ICON = chalk.green('\u2714 ');

export const FAILED_ICON = chalk.red('\u2717 ');
